<template>
	<div class="recharge-main-div">
		<p>
			<span class="name">
				{{$t('vip.credit.balance')}}:
			</span>
			<span class="focus-font">
					{{ loginUser.account.balance }}
			</span>
			<span v-if="currency === 'CNY'">
				( ¥1 = 10 {{$t('vip.credit.name')}} )
			</span>
			<span v-else>
				( $0.5 = 10 credit )
			</span>
		</p>
		<div>
			<span class="name">
				{{$t('vip.recharge.history.name')}}:
			</span>
			<span>
				{{$t('vip.recharge.history.tips')}}
			</span>
			<span class="focus-font"> {{ loginUser.account.accumulateRecharge || 0 }} </span>
		</div>
		<div class="box-div">
			<div class="name">
				{{$t('vip.recharge.items')}}:
			</div>
			<div class="recharge-list">
				<el-row :gutter="20">
					<el-col :span="4" v-for="(item,index) in rechargeList" :key="index">
						<div @click="changeCharge(item)"
							:class="'item' + (rechargeObj && rechargeObj.id === item.id ? ' active' : '') ">
							<!-- <div style="font-size: 18px">
								{{ item.title }}
							</div> -->
							<span style="font-size: 18px;">{{ item.title }}</span>
							<br/>
							<span style="color: #F56C6C;">{{getSymbolByCurrency(currency)}}{{item.amount}} </span><span style="text-decoration: line-through;color: #909399;" v-if="item.amount < item.actualCost"> {{getSymbolByCurrency(currency)}}{{ item.actualCost }}</span>
							<br/>
							<!-- <div class="subhead">
								{{ item.subhead }}
								<span v-if="item.discount < 1">
										({{     $accMul(item.discount ,10)  }} {{ currency === 'USD' ? 'discount' : '折' }})
								</span>
							</div> -->
							<span class="active-icon el-icon-check"></span>
						</div>
					</el-col>
					<!-- <el-col :span="8">
						<div class="item" style="cursor: default">
							<div>更多数量和API请求</div>
							<div class="subhead">请联系客服</div>
						</div>
					</el-col> -->
				</el-row>
			</div>
		</div>

<!--		<div>-->
<!--			<span class="name">-->
<!--				支付货币:-->
<!--			</span>-->
<!--			<span>-->
<!--				-->
<!--			</span>-->
<!--		</div>-->

		<div>
			<span class="name">{{$t('vip.payment.amount')}}:</span>
			<span class="focus-font" style="color:#F56C6C;margin-right: 5px" v-if="rechargeObj">{{getSymbolByCurrency(rechargeObj.currency)}}{{ rechargeObj.amount }}</span>
		</div>

		<div class="box-div" v-loading="checkLoading != null && checkLoading">
			<span class="name">{{$t('vip.payment.name')}}:</span>

			<div v-if="currency === 'CNY'">
				<el-radio-group size="medium" v-model="recharge.payMethod" @change="createOrder(null)"
					:disabled="!rechargeObj || qrCodeLoading">
					<el-radio-button v-for="item in payment_methods.filter(i => i.currency === 'CNY')"
						 :disabled="item.disabled" :key="item.value" :label="item.value" border>
						<i :class="item.icon"></i>
						{{ item.name }}
					</el-radio-button>
				</el-radio-group>
				<div style="margin-top: 20px">
					<el-image :src="qrCode" style="width: 260px;height: 260px" fit="scale-down" v-loading="qrCodeLoading">
						<div slot="error"
							style="background-color: #f5f5f5;height: 100%;line-height: 260px;text-align: center">
							{{$t('vip.payment.tips')}}
						</div>
					</el-image>
				</div>
			</div>
			<div v-else  v-loading="!!checkOrderTimer">
				<paypal-sub v-if="recharge.chargeId" :chargeId="recharge.chargeId" @onApprove="checkOrderStatus"></paypal-sub>
			</div>
		</div>
	</div>
</template>

<script>
import { api_list_charge } from "@/components/api/charge";
import { api_create_payOrder, api_status_payOrder } from "@/components/api/payOrder";
import paypalSub from "@/components/template/pay/payPalSub";

export default {
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_LOGIN'],
	name: "recharge",
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			qrCodeLoading: false,
			qrCode: null,
			rechargeObj: null,
			recharge: {
				chargeId: null,
				payMethod: ''
			},
			rechargeList: [],
			checkOrderTimer: null,
			checkNum: 0,
			checkLoading : null,
			openWindow : null
		}
	},
	components: {
		'paypal-sub' : paypalSub
	},
	created() {
		this.loadChargeData(this)
	},
	beforeDestroy() {
		clearTimeout(this.$data.checkOrderTimer)
	},
	computed: {
		currencies() { 
			return [
				{	value : 'CNY' , code : '￥' , name : this.$t('vip.currency.CNY')	} ,
				{	value : 'USD' , code : '$' , name : this.$t('vip.currency.USD')	},
			]
		},
		currency() {
			return this.$store.getters.currency;
		},
		language() {
      		return this.$store.getters.language;
    	},
		payment_methods() { 
			return [
				{ value: 1, key: "wp", name: this.$t('vip.payment.methods.wechat'), disabled: false, currency: 'CNY', icon : 'fa fa-weixin' },
				{ value: 2, key: "ap", name: this.$t('vip.payment.methods.alipay'), disabled: false, currency: 'CNY', icon : 'fa fa-alipay' },
				{ value: 3, key: "pp", name: this.$t('vip.payment.methods.paypal'), disabled: false, currency: 'USD', icon : 'fa fa-paypal' }
			]
		}
	},
	methods: {
		changeCharge : function(item){
			let this_ = this;
			this_.$data.rechargeObj = item
			this_.$data.recharge.chargeId=item.id;
			this_.$data.recharge.payMethod=null;
			this_.$data.qrCode = null
			this_.$data.checkLoading = false
			clearTimeout(this_.$data.checkOrderTimer)
		},
		// currencyChange : function(currency) {
		// 	// this.$data.currency = currency
		// 	this.$data.rechargeObj = null
		// 	this.$data.recharge.chargeI = null
		// 	this.$data.recharge.payMethod = null
		// 	this.$data.qrCode = null
		// 	this.$data.checkLoading = false
		// 	clearTimeout(this.$data.checkOrderTimer)
		// 	this.loadChargeData(this)
		// },
		loadChargeData: function(this_) {
			this_ = this_ || this
			// 开启遮罩
			this_.F_windowLoading(true)
			// console.log(this.$store.state.app.language)
			// console.log(this.$store.state.app.timezone)
			console.log(this.$store.state.app.currency)
			api_list_charge(1, this.$store.state.app.currency).then(res => {
				this_.$data.rechargeList = res.data.list
				// this_.$data.currency = res.data.currency

				this_.$data.qrCode = null
				// 关闭遮罩
				this_.F_windowLoading(false, null)
			}).catch(err => {
				this_.F_alertMsg(this_.F_getErrMSg(err, '充值列表加载错误，请刷新重试'), 4)
				// 关闭遮罩
				this_.F_windowLoading(false, null)
			})
		},
		checkOrderStatus: function(this_, code) {
			this_ = this_ || this
			this_.$data.checkNum++

			if (this_.$data.openWindow){
				this_.$data.checkLoading = true
				if (this_.$data.openWindow.closed){
					this_.$data.checkLoading = false
					clearTimeout(this_.$data.checkOrderTimer)
					this_.F_alertMsg('已取消支付', 3)
					return
				}
			}
			api_status_payOrder(code).then(res => {
				if (res.data.payStatus || this_.$data.checkNum === 60 * 20) {
					clearTimeout(this_.$data.checkOrderTimer)
					this_.$data.checkOrderTimer = null
					this_.F_alertMsg('充值成功' , 2)
					this_.$data.recharge.payMethod = null
					this_.$data.qrCode = null
					// 刷新钱包数据
					this_.F_LOGIN()
					return
				}
				this_.$data.checkOrderTimer = setTimeout(() => {
					this_.$options.methods.checkOrderStatus(this_, code)
				}, 1000);
			}).catch(err => {
				clearTimeout(this_.$data.checkOrderTimer)
				this_.F_alertMsg(this_.F_getErrMSg(err, ''), 4)
			})
		},
		createOrder: function(this_) {
			this_ = this_ || this
			let pamars = this_.$data.recharge
			if (this_.$data.qrCodeLoading || !pamars.payMethod) {
				return
			}
			// 开启遮罩
			this_.$data.qrCodeLoading = true
			clearTimeout(this_.$data.checkOrderTimer)
			api_create_payOrder(pamars.chargeId, pamars.payMethod, window.location.href).then(res => {
				let data = res.data
				if (data.qrCode) {
					this_.$data.qrCode = data.qrCode;
				}
				this_.$options.methods.checkOrderStatus(this_, res.data.orderId)
				// 关闭遮罩
				this_.$data.qrCodeLoading = false
			}).catch(err => {
				// 关闭遮罩
				this_.$data.qrCodeLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '充值加载错误，请重试'), 4)
			})
		},
		getSymbolByCurrency : function(currency) {
			return this.currencies.find(i => i.value === currency).code
		}
	},
	watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		},
		currency: {
			handler() {
				this.$data.rechargeObj = null
				this.$data.recharge.chargeI = null
				this.$data.recharge.payMethod = null
				this.$data.qrCode = null
				this.$data.checkLoading = false
				clearTimeout(this.$data.checkOrderTimer)
				this.loadChargeData(this)
			},
			deep: true
		},
	},
}
</script>

<style scoped>
.recharge-main-div {
	padding: 50px 20px 70px 20px;
	font-size: 14px;
	width: 1300px;
	margin: auto;
}

.recharge-main-div > div {
	margin-top: 30px;
}

.focus-font {
	font-size: 30px;
	font-weight: bolder;
}

.box-div {
	display: flex;
}

.name {
	width: 85px;
	display: inline-block;
}

.recharge-list {
	flex: 1;
}

.recharge-list .item {
	border: 2px solid #DCDFE6;
	padding: 12px 0;
	border-radius: 4px;
	margin-bottom: 10px;
	text-align: center;
	position: relative;
	cursor: pointer;
}

.recharge-list .active-icon {
	position: absolute;
	right: 2px;
	bottom: 0;
	z-index: 1;
	color: #fff;
}

.recharge-list .active {
	border-color: #409EFF;
	color: #409EFF ;
}

.recharge-list .active:after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 0;
	border-bottom: 30px solid #409EFF;
	border-left: 30px solid transparent;
}

.recharge-list .item .subhead {
	font-size: 13px;
	margin-top: 6px;
}
</style>